import React from 'react';

import {ResponsiveElementGroup} from 'src/components/responsive-element-group';
import {FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';

import {FormSection} from '@pb/kit-component-form-section';
import {Group} from '@pb/kit-component-group';


export const UserSearchLimitsSkeleton = () => (
    <Group alignItems="start">
        <FormSection headline="Search results limits" info={() => <SkeletonItem width={200} height={28}/>}>
            <ResponsiveElementGroup>
                {Array.from({length: 6}, (limit, i) => (
                    <Group key={i} direction="v" gap="s">
                        <SkeletonItem width={90} height={16}/>
                        <Group direction="v" gap="s">
                            <SkeletonItem width={90} height={16}/>
                            <SkeletonItem width={300} height={32}/>
                        </Group>
                        <Group direction="v" gap="s">
                            <SkeletonItem width={90} height={16}/>
                            <SkeletonItem width={300} height={32}/>
                        </Group>
                    </Group>
                ))}
                <Group direction="v" gap="xs">
                    <SkeletonItem width={90} height={16}/>
                    <Group direction="v" gap="s">
                        <SkeletonItem width={90} height={16}/>
                        <SkeletonItem width={300} height={32}/>
                    </Group>
                </Group>
            </ResponsiveElementGroup>
        </FormSection>
        <FormSection headline="Preview" info={() => <SkeletonItem width={200} height={28}/>}>
            <ResponsiveElementGroup padding="0 32px 32px 0">
                {Array.from({length: 6}).map((_limit, i) => (
                    <FormItemSkeleton labelWidth={84} key={i}>
                        <div style={{paddingTop: 8}}>
                            <Group direction="v" gap="s">
                                <Group justify="space-between">
                                    <SkeletonItem width={60} height={20}/>
                                    <SkeletonItem width={60} height={20}/>
                                </Group>
                                <Group justify="space-between">
                                    <SkeletonItem width={60} height={20}/>
                                    <SkeletonItem width={60} height={20}/>
                                </Group>
                            </Group>
                        </div>
                    </FormItemSkeleton>
                ))}
            </ResponsiveElementGroup>
        </FormSection>
    </Group>
);
